/**
 * Main theme entry point
 * Imports SCSS (extracted to build/main.css by webpack) and all JS modules
 */

import './../../assets/scss/main.scss';

import { initNavigation } from './modules/navigation.js';
import { initAnimations }  from './modules/observer.js';
import { initParallax }    from './modules/parallax.js';
import { initAnalytics }   from './modules/analytics.js';

document.addEventListener( 'DOMContentLoaded', () => {
	initNavigation();
	initAnimations();
	initParallax();
	initAnalytics();
} );
